import { actionTypes } from '../actions/campaigns.action';
const initialState = {
    status: [],
    chart: {
        period: {
            period_chart: [],
            today: {}, 
            campaigns: [],
            stats: {}
        },
        hour: {
            best_hour: {},
            best_window: {},
            hourly_chart: [],
            campaigns: [],
        },
        campaign: {}
    },
    campaigns: {
        data: []
    },
    campaign: {
        fotos: []
    },
	plus: {
        title: null,
        primeiro: null,
        segundo: null,
        terceiro: null
    },
    search: {
        user: {},
        cota: {}
    },
    random: [],
    error: {},
    success: false
}

const campaignsReducer = (state = initialState, { type, payload, isLoadMore, campaign_id }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.campaigns.data = state.campaigns.data.concat(payload.campaigns.data)
        }

        return { ...state, ...payload }

    case actionTypes.CHART:
        return {
            ...state,
            chart: {
                campaign: payload?.campaign,
                period: {
                    ...state.chart.period,
                    ...payload.period
                },
                hour: {
                    ...state.chart.hour,
                    ...payload.hour
                }
            }
        }

    case actionTypes.LOADING:
        let uid = state.campaigns.data.findIndex(item => item.id === payload.id)
        state.campaigns.data[uid].loading = payload.loading

        return { ...state, ...payload }

    case actionTypes.CHANGE:
        return {
            ...state,
            plus: (payload === 'clear') ? {
                title: null,
                primeiro: null,
                segundo: null,
                terceiro: null
            } : {
                ...state.plus,
                ...payload
            },
            campaign: (payload === 'clear') ? { fotos: [] } : {
                ...state.campaign,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default campaignsReducer